export * from './IconRigiss';
